<ng-container *ngIf="{ message: messageObserver$ | async } as data">
  <div class="message transition ease-in-out duration-300 text-sm font-primary text-white visible rounded" *ngIf="data.message.showSnackBar" [ngClass]="'bg-' + stateColors[data.message.msgType]" [innerHTML]="data.message.message"></div>
</ng-container>
